<template>
  <div>
    <div class="content" id="top">
      <div v-if="false && eligibleToClaimNumbers" class="dedicated-number">
        <div class="text">
          <div class="title">
            <i class="fa fa-exclamation-circle"></i>
            Claim your dedicated phone number
          </div>
          <div class="details">
            Choose from a list of numbers and make it yours!
          </div>
        </div>
        <div class="button-container">
          <button
            @click="
              () => {
                showChooseNumber = !showChooseNumber;
              }
            "
            class="button-default button-default--white big"
          >
            <span>Claim</span>
          </button>
        </div>
      </div>
      <div class="title-text">
        <div class="title-container">
          <p class="title">Drops</p>

          <div class="new-drop new-drop-mobile" v-if="smsActivated">
            <button class="button-default" @click="newDrop = true">
              <div class="icon">
                <i class="fa-solid fa-plus"></i>
              </div>
              <span class="text">New Drop</span>
            </button>
          </div>
        </div>
        <!-- <p class="subtitle none">
          Manage your Forever Pre-saves and New Music SMS Alerts.
        </p> -->
      </div>
      <div v-if="$apolloData.loading" class="content-body">Loading...</div>
      <div v-else class="content-body">
        <ChooseNumber
          v-if="showChooseNumber"
          @close="closeChooseNumber"
          :artist_id="artist.id"
          @numberChosen="refetchNumbers"
        />

        <BulkMessageInput
          v-if="editingMessage || newDrop"
          :fans="subscribers"
          :submitting="submitting"
          :editingMessage="editingMessage"
          @submit="submit"
          @close="(editingMessage = null), (newDrop = false)"
        />

        <DropSettings v-if="dropSettings" @close="(dropSettings = false)" />

        <Tabs
          :tab-headers="[
            {
              name: 'Subscribers',
              id: 'Subscribers',
              count: fans.length || null,
            },
            {
              name: 'Scheduled Drops',
              count: scheduled_messages.length || null,
              id: 'Scheduled_Drops',
            },
            {
              name: 'Previous Drops',
              id: 'Previous_Drops',
              count: sent_messages.length || null,
            },
          ]"
        >
          <template v-slot:Subscribers>
            <div class="">
              <FiltersSwitcherBtn
                @switch="switchShowFilters"
                class="filters-switcher"
                :class="showFiltersMobile ? 'none' : ''"
              />
              <div class="summary" :class="showFiltersMobile ? 'none' : ''">
                <div class="card">
                  <span class="total">{{ summary.email || 0 }}</span>
                  <span class="label">Email</span>
                </div>
                <div class="card">
                  <span class="total">{{ summary.phone_number || 0 }}</span>
                  <span class="label">SMS</span>
                </div>
                <div class="card">
                  <span class="total">{{ summary.spotify || 0 }}</span>
                  <span class="label">Forever Spotify Presaves</span>
                </div>
                <div class="card">
                  <span class="total">{{ summary.applemusic || 0 }}</span>
                  <span class="label">Forever Apple Music Presaves</span>
                </div>
              </div>

              <div class="fans">
                <div
                  class="filters"
                  :class="showFiltersMobile ? '' : 'hide-filters-mobile'"
                >
                  <div class="title filters-title">Filters</div>
                  <button
                    v-if="showClearFilters"
                    class="button-default"
                    @click="clearFilters"
                  >
                    <span>Clear Filters</span>
                    <RemoveIcon />
                  </button>
                  <div class="section">
                    <div class="title">Channels</div>
                    <label class="checkbox bounce">
                      <input type="checkbox" v-model="email_shared" />
                      <CheckIcon />
                      <span>Email</span>
                    </label>
                    <label class="checkbox bounce">
                      <input type="checkbox" v-model="phone_number_shared" />
                      <CheckIcon />
                      <span>SMS</span>
                    </label>
                    <label class="checkbox bounce">
                      <input type="checkbox" v-model="spotify_presaves" />
                      <CheckIcon />
                      <span>Forever Spotify Presaves</span>
                    </label>
                    <label class="checkbox bounce">
                      <input type="checkbox" v-model="applemusic_presaves" />
                      <CheckIcon />
                      <span>Forever Apple Music Presaves</span>
                    </label>
                  </div>
                  <div class="section">
                    <div class="title">Country</div>
                    <div class="input-container">
                      <input
                        v-model="country"
                        type="text"
                        placeholder="Type to search..."
                      />
                    </div>
                  </div>
                  <div class="section">
                    <div class="title">Region / State</div>
                    <div class="input-container">
                      <input
                        v-model="region"
                        type="text"
                        placeholder="Type to search..."
                      />
                    </div>
                  </div>
                  <div class="section">
                    <div class="title">City</div>
                    <div class="input-container">
                      <input
                        v-model="city"
                        type="text"
                        placeholder="Type to search..."
                      />
                    </div>
                  </div>
                  <div class="section">
                    <div @click="$refs.select.click()" class="select">
                      <label>
                        <span class="label">Source</span>
                      </label>
                      <select
                        ref="select"
                        v-model="source"
                        class="standard-select custom-select"
                      >
                        <option
                          v-for="val in sources"
                          :value="val.id"
                          :key="val.id"
                        >
                          {{ val.title }}
                        </option>
                      </select>
                      <ChevronDownIcon class="pointer-events-none" />
                      <span class="focus"></span>
                    </div>
                  </div>
                  <div class="mobile-filter-buttons">
                    <div class="mobile-filter-cancel">
                      <button
                        class="filter-cancel-btn button-default"
                        @click="closeFilters"
                      >
                        <span>Cancel</span>
                      </button>
                    </div>
                    <div class="mobile-filter-apply">
                      <button
                        class="filter-apply-btn button-default"
                        @click="applyFilters"
                      >
                        <span>Apply Filters</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="results" :class="showFiltersMobile ? 'none' : ''">
                  <div class="results-title">
                    <div class="matches">
                      {{ filteredFans.length }} of {{ fans.length }} Drop
                      Subscribers
                    </div>
                    <button
                      class="button-default export-btn"
                      @click="exportUsers"
                    >
                      <span>Export Users</span>
                      <ExportIcon />
                    </button>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th align="left">Channel</th>
                        <th align="left">Contact</th>
                        <th align="left">Country</th>
                        <th align="left">Region</th>
                        <th align="left">City</th>
                        <th align="left">Source</th>
                        <th align="left">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="fan in fansPerPage" :key="fan.id" class="row">
                        <td>{{ fan.channel | platformLabel }}</td>
                        <td v-if="fan.channel == 'text'">
                          <!--eslint-disable-next-line prettier/prettier-->
                          {{ fan.contact | formatNumber }}
                        </td>
                        <td v-else>{{ formatContact(fan.contact) || "-" }}</td>
                        <td>{{ fan.country || "-" }}</td>
                        <td>{{ fan.region || "-" }}</td>
                        <td>{{ fan.city || "-" }}</td>
                        <router-link
                          tag="td"
                          v-if="fan.source_link"
                          :to="{
                            name: 'SmartLink',
                            params: { id: fan.source_link.id },
                          }"
                        >
                          <a>
                            {{ fan.source_link.title }}
                          </a>
                        </router-link>
                        <td v-else>
                          <span>-</span>
                        </td>
                        <td>{{ fan.created_at | formatDateFans }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <template v-if="pages > 1">
                    <div class="pagination" v-if="pages < 6">
                      <div
                        class="page"
                        :class="{ active: page === n }"
                        v-for="(n, index) in pages"
                        :key="index"
                        @click="page = n"
                      >
                        {{ n }}
                      </div>
                    </div>
                    <div class="pagination" v-else>
                      <template v-if="page === 1">
                        <div class="page active">{{ page }}</div>
                        <div class="page" @click="page = page + 1">
                          {{ page + 1 }}
                        </div>
                        <div class="page" @click="page = page + 2">
                          {{ page + 2 }}
                        </div>
                        <div class="dots">...</div>
                        <div class="page" @click="page = pages">
                          {{ pages }}
                        </div>
                      </template>
                      <template v-else-if="pages - page > 2">
                        <div class="page" @click="page = page - 1">
                          {{ page - 1 }}
                        </div>
                        <div class="page active">{{ page }}</div>
                        <div class="page" @click="page = page + 1">
                          {{ page + 1 }}
                        </div>
                        <div class="dots">...</div>
                        <div class="page" @click="page = pages">
                          {{ pages }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="page" @click="page = 1">{{ 1 }}</div>
                        <div class="dots">...</div>
                        <div
                          class="page"
                          :class="{ active: page === pages - 2 }"
                          @click="page = pages - 2"
                        >
                          {{ pages - 2 }}
                        </div>
                        <div
                          class="page"
                          :class="{ active: page === pages - 1 }"
                          @click="page = pages - 1"
                        >
                          {{ pages - 1 }}
                        </div>
                        <div
                          class="page"
                          :class="{ active: page === pages }"
                          @click="page = pages"
                        >
                          {{ pages }}
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:Scheduled_Drops>
            <div class="messages-container" v-if="!editingMessage">
              <div class="card-top">
                <span class="card-title">Scheduled Drops</span>
              </div>
              <div class="card-content">
                <div
                  class="messages scheduled"
                  v-if="scheduled_messages.length"
                >
                  <div
                    class="message-container"
                    v-for="(message, i) in scheduled_messages"
                    :key="i"
                  >
                    <div class="details">
                      <div class="element">
                        <div class="icon">
                          <i class="fa-solid fa-users"></i>
                        </div>
                        <div class="text">
                          {{ message | formatSendTo }}
                        </div>
                      </div>
                      <div class="element">
                        <div class="icon">
                          <i class="fa-solid fa-dollar-sign"></i>
                        </div>
                        <div class="text">
                          ${{ subscribers | formatCost(message.location) }}
                        </div>
                      </div>
                      <div class="element">
                        <div class="icon">
                          <i class="fa-solid fa-clock"></i>
                        </div>
                        <div class="text" v-if="!message.link_destination">
                          {{ message | formatDate }}
                        </div>
                        <div class="text" v-else>On Release</div>
                      </div>
                      <div class="actions">
                        <button
                          class="button-default"
                          @click="editingMessage = message"
                        >
                          <div class="icon">
                            <i class="fa-solid fa-pencil"></i>
                          </div>
                          <span class="text">Edit</span>
                        </button>
                      </div>
                    </div>
                    <div class="message">
                      <span>{{ message.message }}</span>
                      <span class="link">{{ message.sms_link }}</span>
                    </div>
                  </div>
                </div>
                <div class="no-messages" v-else>
                  <span class="message-text">
                    You don't have any scheduled drops
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:Previous_Drops>
            <div class="messages-container" v-if="!editingMessage">
              <div class="card-top">
                <span class="card-title">Previous Drops</span>
              </div>
              <div class="card-content">
                <div class="messages" v-if="sent_messages.length">
                  <div
                    class="message-container"
                    v-for="(message, i) in sent_messages"
                    :key="i"
                  >
                    <div class="details">
                      <div class="element">
                        <div class="icon">
                          <i class="fa-solid fa-users"></i>
                        </div>
                        <div class="text">
                          {{ (message.recipient_count || 0) + " Subscribers" }}
                        </div>
                      </div>
                      <!--
                  <div class="element">
                    <div class="icon">
                      <i class="fa-solid fa-hand-back-point-up"></i>
                    </div>
                    <div class="text">
                      283 Clicks
                    </div>
                  </div>
                  -->
                      <div class="element">
                        <div class="icon">
                          <i class="fa-solid fa-reply"></i>
                        </div>
                        <div class="text">
                          {{ message.replies.aggregate.count }} Replies
                        </div>
                      </div>
                      <div class="element">
                        <div class="icon">
                          <i class="fa-solid fa-ban"></i>
                        </div>
                        <div class="text">
                          {{ message.optouts.aggregate.count }} Opt-outs
                        </div>
                      </div>
                    </div>
                    <div class="message">
                      <span>{{ message.message }}</span>
                      <span class="link">{{ message.sms_link }}</span>
                    </div>
                    <div class="time">{{ message | formatDate }}</div>
                  </div>
                </div>
                <div class="no-messages" v-else>
                  <span class="message-text">
                    You haven't sent any drops yet
                  </span>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:actions>
            <div class="left-menu">
              <div class="new-drop new-drop-desktop">
                <button class="button-default" @click="newDrop = true">
                  <div class="icon">
                    <i class="fa-solid fa-plus"></i>
                  </div>
                  <span class="text">New Drop</span>
                </button>
              </div>
              <div class="drop-settings">
                <button class="button-secondary" @click="dropSettings = true">
                  <div class="icon">
                    <i class="fa-light fa-gear fa-xl"></i>
                  </div>
                  <span class="text">Drop Settings</span>
                </button>
              </div>
            </div>
          </template>
        </Tabs>
      </div>
      <SnackBar />
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Swal from "sweetalert2";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import RemoveIcon from "../../../../public/img/icons/remove.svg";
import ExportIcon from "../../../../public/img/icons/export.svg";
import CheckIcon from "../../../../public/img/icons/check.svg";
import ChevronDownIcon from "../../../../public/img/icons/chevron-down.svg";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import SnackBar from "@/components/Custom/SnackBar";
import BulkMessageInput from "@/components/Custom/BulkMessageInput";
import FiltersSwitcherBtn from "@/components/Custom/FiltersSwitcherBtn";
import DropSettings from "@/components/Custom/DropSettings";
import ChooseNumber from "../../../components/Custom/ChooseNumber.vue";
import Tabs from "@/components/Tabs";
import {
  Q_FANS,
  Q_SUBSCRIBERS_COUNT,
  M_SCHEDULE_MESSAGE,
  Q_SCHEDULED_MESSAGES,
  M_UPDATE_SCHEDULED_MESSAGE,
  M_DELETE_SCHEDULED_MESSAGE,
  Q_SENT_MESSAGES,
  Q_GET_PHONE_NUMBERS_BY_ARTIST,
} from "@/graphql";

const getInitialState = () => ({
  email_shared: false,
  phone_number_shared: false,
  applemusic_presaves: false,
  spotify_presaves: false,
  country: "",
  region: "",
  city: "",
  source: "",
  page: 1,
});

export default {
  name: "Fans",
  components: {
    RemoveIcon,
    ExportIcon,
    SnackBar,
    CheckIcon,
    ChevronDownIcon,
    BulkMessageInput,
    FiltersSwitcherBtn,
    ChooseNumber,
    Tabs,
    DropSettings
  },
  data() {
    const initialfilters = getInitialState();
    return {
      windowWidth: window.innerWidth,
      ...initialfilters,
      initialfilters,
      fans: [],
      summary: {},
      ...getInitialState(),
      newDrop: false,
      dropSettings: false,
      subscribers: {
        world: 0,
        us_canada: 0,
      },
      submitting: false,
      scheduled_messages: [],
      sent_messages: [],
      editingMessage: null,
      showChooseNumber: false,
      artistNumbers: [],
      showFiltersMobile: false,
    };
  },
  apollo: {
    fans: {
      query: Q_FANS,
      update(data) {
        const subscriptions = data.presave_subscriptions.map(
          ({ presave_token, ...rest }) => ({
            ...rest,
            channel: presave_token.provider,
            presave: true,
          })
        );

        const fans = [...data.optins_message, ...subscriptions];

        this.summary = {};
        fans.forEach(({ channel }) => {
          this.summary[channel] = (this.summary[channel] || 0) + 1;
        });

        return fans.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      },
      variables() {
        return {
          artist_id: this.artist.id,
        };
      },
    },
    subscribers_count: {
      query: Q_SUBSCRIBERS_COUNT,
      result({ data }) {
        this.subscribers = {
          world: data.subscribers_world.aggregate.count,
          us_canada: data.subscribers_us_canada.aggregate.count,
        };
      },
      variables() {
        return {
          artist_id: this.artist.id,
        };
      },
      update: (data) => data,
    },
    scheduled_messages: {
      query: Q_SCHEDULED_MESSAGES,
      result({ data }) {
        this.scheduled_messages = data.bulk_messages;
      },
      variables() {
        return {
          artist_id: this.artist.id,
          now: new Date(),
        };
      },
      update: (data) => data,
    },
    sent_messages: {
      query: Q_SENT_MESSAGES,
      result({ data }) {
        this.sent_messages = data.bulk_messages;
      },
      variables() {
        return {
          artist_id: this.artist.id,
          now: new Date(),
        };
      },
      update: (data) => data,
    },
    phoneNumbersByArtist: {
      query: Q_GET_PHONE_NUMBERS_BY_ARTIST,
      result({ data }) {
        this.phoneNumbersByArtist = data.phone_numbers;
      },
      variables() {
        return {
          artist_id: this.artist.id,
        };
      },
      update: (data) => data,
    },
  },
  async created() {
    // TODO: Re-enable after fixing subs
    // if (!this.subscriptionActive(this.artist)) {
    // await this.$router.push({ name: "ArtistSettings" });
    // }
    // this.refetchNumbers();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  async beforeMount() {
    await this.refetchNumbers();
  },
  filters: {
    formatNumber(val) {
      if (!val) return "-";
      const phoneUtil = PhoneNumberUtil.getInstance();
      const number = phoneUtil.parseAndKeepRawInput(val);
      const valid = phoneUtil.isValidNumber(number);
      if (!valid) return val;
      return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
    },
    platformLabel(val) {
      switch (val) {
        case "email":
          return "Email";
        case "phone_number":
          return "SMS";
        case "spotify":
          return "Spotify Presave";
        case "applemusic":
          return "Apple Music Presave";
        default:
          return "";
      }
    },
    formatDate(message) {
      return message.link_destination
        ? moment(message.link_destination.link.release_time).format(
            "MMM DD, YYYY hh:mm a"
          )
        : moment(message.send_at).format("MMM DD, YYYY hh:mm a");
    },
    formatDateFans(date) {
      return moment(date).format("MM/DD/YY");
    },
    formatSendTo(message) {
      if (message.location === "world") return "Worldwide";
      if (message.location === "us_canada") return "US & Canada";
      if (message.link_destination) return "Drop Subscribers + Worldwide";
    },
    formatCost(subscribers, location) {
      const costUsCanada = subscribers.us_canada * 0.01;
      const costWorldRest = (subscribers.world - subscribers.us_canada) * 0.05;
      const cost =
        location === "us_canada" ? costUsCanada : costWorldRest + costUsCanada;
      return cost.toFixed(2);
    },
    formatSentTo(message, count) {
      let description = "";
      if (message.location === "world") description = "Worldwide";
      if (message.location === "us_canada") description = "US & Canada";
      if (message.link_destination)
        description = "Drop Subscribers + Worldwide";

      if (count) description += ` (${count} fans)`;

      return description;
    },
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    snack() {
      return this.$store.getters.getSnack;
    },
    smsActivated() {
      return this.$store.getters.getActivatedFeatures.includes("sms");
    },
    filteredFans() {
      return (this.fans || []).filter((el) => this.filter(el));
    },
    pages() {
      return Math.ceil(this.filteredFans.length / 25);
    },
    fansPerPage() {
      const offset = (this.page - 1) * 25;
      return this.filteredFans.slice(offset, offset + 25);
    },
    showClearFilters() {
      const {
        email_shared,
        phone_number_shared,
        spotify_presaves,
        applemusic_presaves,
        country,
        city,
        region,
      } = this;

      return (
        country ||
        region ||
        city ||
        email_shared ||
        phone_number_shared ||
        spotify_presaves ||
        applemusic_presaves
      );
    },
    canClaimNumber() {
      return (
        this.$store.getters.getUser.artists[0]?.phone_numbers?.length == 0 &&
        this.artistNumbers?.length == 0 &&
        this.artist.current_plan == "max"
      );
    },
    eligibleToClaimNumbers() {
      return (
        this.phoneNumbersByArtist &&
        !this.phoneNumbersByArtist.length &&
        this.artist.active_plan == "max"
      );
    },
    sources() {
      return this.fans.reduce(
        (acc, fan) => {
          if (
            fan.source_link &&
            !acc.find((el) => el.id === fan.source_link.id)
          ) {
            acc.push(fan.source_link);
          }
          return acc;
        },
        [{ id: "", title: "Any" }]
      );
    },
  },
  methods: {
    filter(el) {
      const {
        email_shared,
        phone_number_shared,
        spotify_presaves,
        applemusic_presaves,
        country,
        city,
        region,
        source,
      } = this;

      let applicable = false;

      if (
        !email_shared &&
        !phone_number_shared &&
        !spotify_presaves &&
        !applemusic_presaves
      )
        applicable = true;
      else if (email_shared && el.channel === "email") applicable = true;
      else if (spotify_presaves && el.channel === "spotify") applicable = true;
      else if (phone_number_shared && el.channel === "phone_number")
        applicable = true;
      else if (applemusic_presaves && el.channel === "applemusic")
        applicable = true;

      if (country && country !== el.country) applicable = false;
      if (city && city !== el.city) applicable = false;
      if (region && region !== el.region) applicable = false;
      if (source && source !== el.source_link?.id) applicable = false;

      return applicable;
    },
    clearFilters() {
      Object.assign(this, getInitialState());
    },
    exportUsers() {
      const fans = this.filteredFans.map(
        ({ id, channel, contact, country, region, city }) => ({
          id,
          channel,
          contact,
          country: country || "-",
          region: region || "-",
          city: city || "-",
        })
      );
      const csvContent =
        "data:text/csv;charset=utf-8," +
        [
          Object.keys(fans[0]).join(";"),
          ...fans.map((item) => Object.values(item).join(";")),
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "subscribers.csv");
      link.click();
    },
    async submit(data) {
      return this.editingMessage
        ? await this.editMessage(data)
        : await this.scheduleMessage(data);
    },
    async scheduleMessage({ send_at, message, location, sms_link }) {
      if (!send_at) {
        const { value: confirm } = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonText: "Yes, send it!",
          type: "warning",
          confirmButtonClass: "button-secondary big",
          cancelButtonClass: "button-danger big",
          buttonsStyling: false,
        });

        if (!confirm) return;
      }

      this.submitting = true;

      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_SCHEDULE_MESSAGE,
        variables: {
          artist_id: this.artist.id,
          message,
          location,
          sms_link: sms_link || null,
          send_at: send_at
            ? moment
                .parseZone(
                  `${send_at.date} ${send_at.time}${moment(send_at.date)
                    .tz(send_at.timezone)
                    .format("Z")}`
                )
                .format()
            : new Date(),
          timezone: send_at ? send_at.timezone : null,
        },
      });

      this.submitting = false;
      this.newDrop = false;

      if (send_at) await this.$apollo.queries.scheduled_messages.refetch();
    },
    async editMessage({ id, send_at, message, location, sms_link }) {
      if (!send_at) {
        const { value: confirm } = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonText: "Yes, send it!",
          type: "warning",
          confirmButtonClass: "button-secondary big",
          cancelButtonClass: "button-danger big",
          buttonsStyling: false,
        });

        if (!confirm) return;
      }

      this.submitting = true;

      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_UPDATE_SCHEDULED_MESSAGE,
        variables: {
          id,
          message,
          location,
          sms_link: sms_link || null,
          send_at: send_at
            ? moment
                .parseZone(
                  `${send_at.date} ${send_at.time}${moment(send_at.date)
                    .tz(send_at.timezone)
                    .format("Z")}`
                )
                .format()
            : new Date(),
          timezone: send_at ? send_at.timezone : null,
        },
      });

      this.submitting = false;
      this.editingMessage = null;

      return this.$apollo.queries.scheduled_messages.refetch();
    },
    async deleteMessage(id) {
      const { value: confirm } = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        type: "warning",
        confirmButtonClass: "button-secondary big",
        cancelButtonClass: "button-danger big",
        buttonsStyling: false,
      });

      if (!confirm) return;

      await this.$apollo.mutate({
        client: "localClient",
        mutation: M_DELETE_SCHEDULED_MESSAGE,
        variables: {
          id,
        },
      });

      await this.$apollo.queries.scheduled_messages.refetch();
    },
    closeChooseNumber() {
      this.showChooseNumber = false;
    },
    async refetchNumbers() {
      const numbers = await this.$apollo.queries.phoneNumbersByArtist.refetch();
      this.artistNumbers = numbers.data.phone_numbers;
      await this.$store.dispatch(
        "setArtistPhoneNumbers",
        numbers.data.phone_numbers
      );
    },
    applyFilters() {
      this.showFiltersMobile = false;
    },
    closeFilters() {
      Object.assign(this.$data, this.initialfilters);
      this.showFiltersMobile = false;
    },
    switchShowFilters() {
      this.showFiltersMobile = !this.showFiltersMobile;
    },
    formatContact(contact) {
      if (contact && this.windowWidth <= 585 && contact.length > 11) {
        const firstLetter = contact.charAt(0);
        const lastPart = contact.substring(contact.indexOf("@"));
        return `${firstLetter}***${lastPart}`;
      }
      return contact;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  watch: {
    filteredFans() {
      this.page = 1;
    },
    page() {
      document.getElementById("top").scrollIntoView({
        behavior: "smooth",
      });
    },
    artist() {
      this.clearFilters();
    },
  },
};
</script>
<style lang="scss" scoped>
.title-text {
  margin-bottom: 34px;
}
.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 20px;
}

.new-drop-mobile {
  display: none;
}

.new-drop button {
  padding: 10px;
  font-size: 18px;

  .icon {
    margin-right: 6px;
  }
}

.content {
  padding: 36px 18px;
  .content-body {
    .summary {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      .card {
        padding: 10px 10px;
        width: 164px;
        height: 60px;
        background: #24224a;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 8px;

        .total {
          color: #ffffff;
          font-size: 16px;
        }

        .label {
          text-align: center;
          color: #8786ab;
          font-size: 12px;
          margin-top: 3px;
        }
      }
    }

    .filters-switcher {
      margin-left: auto;
      margin-right: 8px;
    }

    .fans {
      display: flex;

      .filters {
        height: max-content;
        margin: 8px;
        padding: 18px;
        background: #24224a;
        box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
        border-radius: 10px;
        width: 250px;

        & > .title {
          font-size: 18px;
          color: #ffffff;
          margin-bottom: 20px;
        }

        .section {
          margin-top: 24px;

          .title,
          label {
            font-size: 12px;
            color: #b1afcd;
            margin-bottom: 12px;
            margin-left: 0;
            font-weight: 500;
          }

          .select {
            select {
              width: 180px;
              margin-top: 0;
            }
            svg {
              top: 35px;
            }
          }

          .checkbox {
            position: relative;
            margin-top: 18px;
            display: flex;
            align-items: center;

            span {
              margin-left: 12px;
              font-size: 14px;
              line-height: 17px;
              /* White */
              color: #ffffff;
              mix-blend-mode: normal;
              opacity: 0.9;
            }

            input,
            svg {
              min-width: 24px;
              height: 24px;
              display: block;
            }

            input {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              position: relative;
              outline: none;
              background: $text-type-0;
              border: none;
              margin: 0;
              padding: 0;
              cursor: pointer;
              border-radius: 5px;
              transition: box-shadow 0.3s;

              &:checked {
                background: $bg-type-1;

                & ~ svg {
                  path {
                    fill: white;
                  }
                }

                & ~ span {
                  color: white;
                }
              }
            }

            svg {
              pointer-events: none;
              fill: none;
              stroke-width: 2px;
              stroke-linecap: round;
              stroke-linejoin: round;
              position: absolute;
              top: 0;
              left: 0;
              width: 24px;
              height: 24px;

              path {
                fill: transparent;
              }
            }
          }

          .input-container {
            input {
              width: 100%;
              padding: 13px 11px;
              background: #100e2a;
              border: 1px solid #312f62;
              box-sizing: border-box;
              border-radius: 5px;
              outline: none;
              color: #b1afcd;
              font-size: 14px;
              line-height: 17px;
            }
          }
        }
      }

      .results {
        max-width: 100%;
        width: 100%;
        margin: 8px;
        padding: 12px;
        background: #24224a;
        box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
        border-radius: 10px;
        overflow-x: auto;

        .results-title {
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;

          .matches {
            font-size: 18px;
            font-weight: 600;
            color: #ffffff;
          }

          button {
            height: 42px;
            border-radius: 10px;

            span {
              font-size: 16px;
            }
          }
        }

        table {
          width: 100%;
          border-collapse: collapse;

          thead {
            tr {
              th {
                padding: 18px;
                padding-left: 10px;
                font-weight: 600;
                font-size: 12px;
                line-height: 15px;
                color: $text-type-0;
              }
            }
          }

          tbody {
            tr {
              background: $bg-type-4;
              border-bottom: solid 5px $bg-type-2;

              td {
                padding: 6px;
                font-size: 14px;
                line-height: 22px;
                color: white;
                mix-blend-mode: normal;
                opacity: 0.9;

                &:first-child {
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
                }

                &:last-child {
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                }

                a {
                  color: $purple;
                  text-decoration: underline;
                  font-size: 14px;
                }
              }
            }
          }
        }

        .pagination {
          float: left;
          width: max-content;
          margin: 15px 0 5px;
          display: flex;

          .page {
            width: 24px;
            height: 24px;
            border: 1px solid transparent;
            border-radius: 4px;
            color: #ffffff;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 6px;

            &:first-child {
              margin-left: auto;
            }

            &.active {
              background: linear-gradient(
                    46.19deg,
                    #9c27b0 5.66%,
                    #9733ee 94.35%
                  )
                  padding-box,
                linear-gradient(46.19deg, #9c27b0 5.66%, #9733ee 94.35%)
                  border-box;

              &:hover {
                cursor: default;
              }
            }

            &:not(&.active) {
              border: 1px solid #59588d;
            }

            &:hover {
              cursor: pointer;
            }
          }

          .dots {
            color: #ffffff;
            margin: 0 4px;
            margin-left: 10px;
          }
        }
      }
    }

    .new-drop, .drop-settings {
      margin-bottom: 20px;
      margin-right: 8px;

      button {
        padding: 10px;
        font-size: 18px;

        .icon {
          margin-right: 6px;
        }

        .text {
          font-size: 14px;
        }
      }
    }

    .left-menu {
      margin-left: auto;
      display: flex;
    }

    .message-card {
      width: 100%;
      background: $bg-type-2;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      padding: 20px;
      margin-bottom: 20px;

      .card-top {
        display: flex;
        justify-content: space-between;

        .title {
          display: flex;
          flex-direction: column;

          .card-title {
            font-size: 18px;
            font-weight: 600;
            color: white;
            margin-bottom: 10px;
          }

          .card-text {
            font-size: 14px;
            font-weight: 400;
            color: $text-type-0;
            margin-bottom: 10px;
          }
        }

        .editing {
          color: $purple;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
        }
      }
    }

    .messages-container {
      width: 100%;
      background: $bg-type-2;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      padding: 20px 35px;
      margin-bottom: 50px;

      .card-top {
        display: flex;
        flex-direction: column;

        .card-title {
          font-size: 18px;
          font-weight: 600;
          color: white;
          margin-bottom: 10px;
        }

        .card-text {
          font-size: 14px;
          font-weight: 400;
          color: $text-type-0;
          margin-bottom: 10px;
        }
      }

      .card-content {
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        .messages {
          display: flex;
          flex-direction: column;
          gap: 45px;

          .message-container {
            width: 100%;

            .details {
              background: #16142b;
              display: flex;
              justify-content: space-around;
              padding: 20px 30px;
              border-radius: 14px 14px 0 0;

              .element {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #fff;

                .text {
                  margin-top: 8px;
                  font-size: 14px;
                  font-weight: 600;
                }
              }

              button {
                padding: 8px 16px;
                display: flex;
                gap: 10px;
                font-size: 15px;
              }
            }

            .message {
              border-radius: 0px 0px 14px 14px;
              padding: 25px;
              background: #16142b;
              color: #fff;
              position: relative;
              font-size: 16px;
              font-weight: 400;
              display: flex;
              flex-direction: column;

              .link {
                margin-top: 15px;
                font-size: 14px;
                font-weight: 600;
                color: #fff;
              }

              &:before {
                content: "";
                position: absolute;
                z-index: 0;
                bottom: 0;
                right: -8px;
                height: 20px;
                width: 20px;
                background: #16142b;
                border-bottom-left-radius: 15px;
              }

              &:after {
                content: "";
                position: absolute;
                z-index: 1;
                bottom: 0;
                right: -10px;
                width: 10px;
                height: 20px;
                background: $bg-type-2;
                border-bottom-left-radius: 10px;
              }
            }

            .time {
              margin-left: auto;
              margin-right: 5px;
              margin-top: 10px;
              width: fit-content;
              color: #c9c9c9;
              font-size: 14px;
              font-style: normal;
            }
          }

          &.scheduled {
            gap: 25px;

            .message-container {
              .details {
                justify-content: space-between;
              }
            }
          }
        }

        .messages-list {
          width: 100%;
          border-collapse: collapse;

          thead {
            tr {
              th {
                padding: 18px 18px 10px 10px;
                font-weight: 600;
                font-size: 12px;
                line-height: 15px;
                color: $text-type-0;
              }
            }
          }

          tbody {
            tr {
              background: $bg-type-1;
              border-bottom: solid 5px transparent;

              td {
                padding: 6px;
                font-weight: 600;
                font-size: 14px;
                line-height: 22px;
                color: white;
                mix-blend-mode: normal;
                opacity: 0.9;

                &:first-child {
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
                }

                &:last-child {
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                }

                &.actions {
                  span {
                    margin: 0 10px;
                    color: $purple;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.mobile-filter-buttons {
  display: none;
}

@keyframes bounce {
  50% {
    transform: scale(1.2);
  }

  75% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

.dedicated-number {
  flex: 1;
  display: flex;
  background: #9c27b0;
  color: white;
  border-radius: 10px;
  padding: 12px 24px;

  margin-bottom: 48px;

  .text {
    display: flex;
    flex-direction: column;
    padding-right: 30px;

    .title {
      font-weight: 900;
      font-size: 16px;
      line-height: 26px;
      color: #ffffff;

      i {
        margin-right: 5px;
      }
    }

    .details {
      margin-top: 5px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    flex: 1;

    button {
      white-space: nowrap;
    }
  }
}

@media screen and (min-width: 1400px) {
  .filters-switcher {
    display: none;
  }
}

@media screen and (max-width: 1400px) {
  .title-text {
    margin-bottom: 32px;
  }
  .filters-switcher {
    height: 24px;
    margin-bottom: 20px;
  }
  .mobile-filter-buttons {
    display: block;
    display: flex;
    margin-top: 40px;
    gap: 16px;
    // margin-left: calc(70% - 229px);
    float: right;
    margin-bottom: 32px;
    .mobile-filter-cancel {
      background: $gradient-type-2;
      padding: 1px;
      border-style: solid;
      border-radius: 6px;
      .filter-cancel-btn {
        background: $bg-type-2;
      }
    }
    button {
      padding: 9px 18px;
    }
  }
  .filters {
    height: max-content;
    position: absolute;
    top: -24px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  .content {
    .content-body {
      position: relative;
      .fans .filters {
        margin-top: 100px;
        padding: 24px;
        > .title {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 40px;
        }
        .section {
          .checkbox {
            font-weight: 600;
            margin-top: 0px;
          }
          .title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 16px;
          }
          .input-container input {
            padding: 12.5px 12px;
          }
        }
      }
    }
  }
  .hide-filters-mobile {
    display: none !important;
  }
  .content .content-body .none {
    display: none;
  }
  .none {
    display: none;
  }

  .fans {
    min-height: 720px;
  }
  .select {
    max-width: none;
    width: 100%;
  }
}

@media screen and (max-width: 1124px) {
  .content {
    padding: 24px 20px;
  }
}

@media screen and (max-width: 1024px) {
  .content .content-body .fans .results {
    margin-bottom: 39px;
  }
}

@media screen and (max-width: 820px) {
  .new-drop-desktop {
    display: none;
  }
  .new-drop-mobile {
    display: block;
    width: 142px !important;
    height: 42px !important;
  }
  .new-drop-mobile button {
    height: 100%;
    width: 100%;
  }
  .summary {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .card {
    height: 100%;
    width: 100% !important;
    margin: 0 !important;
  }
  .page:first-child {
    margin-left: 0 !important;
  }
  .content .content-body .fans .filters {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 90%;
    overflow-y: auto;
    top: auto;
    z-index: 101;
  }
  .select {
    width: 100%;
  }
  .content .content-body .fans .filters .section .input-container input {
    width: 100%;
  }
  .mobile-filter-buttons {
    margin-left: 0px;
    float: right;
  }
}

@media screen and (max-width: 755px) {
  .content .content-body .fans .results table tbody tr td:first-child,
  .content .content-body .fans .results table tbody tr td:last-child,
  .content .content-body .fans .results table thead tr th:first-child,
  .content .content-body .fans .results table thead tr th:last-child {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .content .content-body .fans .results table tbody tr td {
    font-size: 12px;
  }
}

@media screen and (max-width: 500px) {
  .content .content-body .fans .filters {
    width:calc(100% - 18px);
    margin-left: 10px;
  }
  .left-menu {
    margin-left: 20px;
  }
  .title-container {
    margin-bottom: 0;
  }
  .export-btn {
    padding: 10px;
  }
  .export-btn span {
    display: none !important;
  }
  .export-btn svg {
    margin: 0;
  }

  table {
    border-spacing: 0px 6px !important;
    border-collapse: separate !important;
    width: 100%;
  }

  .row {
    margin-bottom: 6px !important;
    border-radius: 6px;
    background: #0a091a !important;
  }

  .row td {
    font-weight: 400 !important;
    font-size: 12px;
    color: #fff;
    white-space: nowrap !important;
    padding: 0;
    padding-right: 10px !important;
  }

  .filters-title {
    font-weight: 700;
  }

  .input-container input {
    width: 100%;
  }
}
</style>
